<template>
    <!-- <body data-spy="scroll" data-target=".site-navbar-target" data-offset="100"> -->

        <Header />
        <div class="template-b">
            <DynamicSection
                v-for="(block, index) in sectionList"
                :key="index"
                :section="block.name"
                :props="block.data"
            />
        </div>
        <Footer />
    <!-- </body> -->
</template>

<script>
import { mapState } from "vuex";
import Header from "@/components/HomeViewSection/Header.vue";
import Footer from "@/components/HomeViewSection/FooterView.vue";
import DynamicSection from "@/components/DynamicSection.vue";

export default {
    name: "TemplateB",
    components: {
        Header,
        DynamicSection,
        Footer
    },
    computed: {
        ...mapState(["sectionList"])
    }
};
</script>

<style src="../assets/css/loyalty.css">

</style>
<!-- <style src="https://measiteassetpublic.zohostratus.in/css/loyalty.css">

</style> -->